__turbopack_context__.v({
  "bannerContainer": "R5xy_q_bannerContainer",
  "buyerProtectionMessage": "R5xy_q_buyerProtectionMessage",
  "zendeskLinkText": "R5xy_q_zendeskLinkText",
});
